// extracted by mini-css-extract-plugin
module.exports = {"dateTitle":"Meetings_dateTitle__1htdQ","list":"Meetings_list__2NKj5","noMeetings":"Meetings_noMeetings__RK_Aj","createMeetingBtn":"Meetings_createMeetingBtn__3PzAQ"};